import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Pencil, Eye, LayoutDashboard, LogOut, Sparkles } from "lucide-react";

export default function EditBar() {
  const { user, editMode, setEditMode, logout } = useApp();
  if (!user) return null;

  return (
    <div className="fixed bottom-5 right-5 z-[60]" data-testid="admin-edit-bar">
      <div className="oj-card !bg-[#014845] !border-teal-400/40 px-3 py-2.5 flex items-center gap-2 shadow-2xl">
        <span className="hidden sm:flex items-center gap-1.5 pr-2 mr-1 border-r border-teal-400/30 text-[11px] font-mono uppercase tracking-wider text-teal-100">
          <Sparkles className="w-3.5 h-3.5 text-amber-300" /> {user.name?.split(" ")[0]}
        </span>
        <button onClick={() => setEditMode(!editMode)} data-testid="toggle-edit-mode"
          className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-xs font-bold transition-all ${editMode ? "bg-amber-400 text-[#014845]" : "bg-white/10 text-white border border-white/25 hover:bg-white/20"}`}>
          {editMode ? <><Eye className="w-3.5 h-3.5" /> Editing ON</> : <><Pencil className="w-3.5 h-3.5" /> Edit Page</>}
        </button>
        <Link to="/admin" data-testid="editbar-admin-link" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold bg-white/10 text-white border border-white/25 hover:bg-white/20">
          <LayoutDashboard className="w-3.5 h-3.5" /> <span className="hidden sm:inline">CMS</span>
        </Link>
        <button onClick={logout} data-testid="editbar-logout" className="grid place-items-center w-8 h-8 rounded-lg bg-red-500/20 text-red-200 hover:bg-red-500/30" title="Sign out">
          <LogOut className="w-4 h-4" />
        </button>
      </div>
      {editMode && (
        <div className="mt-2 text-[10px] text-center font-mono text-teal-700 bg-amber-100 border border-amber-300 rounded-lg px-2 py-1">
          Click any text to edit • hover images to replace
        </div>
      )}
    </div>
  );
}
